var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJewelry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "62px",
    viewBox: "0 0 51 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-describedby": "jewelry-title jewelry-desc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "jewelry-title"
  }, "Jewelry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "jewelry-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "jewelry-desc"
  }, "A diamond ring")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CLY_IconFamily_v2-copy",
    transform: "translate(-856.000000, -432.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(857.000000, 433.851522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,59.1484775 C38.0309764,59.1484775 49,48.1794539 49,34.6484775 C49,23.7669022 41.9059663,14.5422272 32.0904272,11.3469808 C29.7005802,10.5690154 27.149401,10.1484775 24.5,10.1484775 C22.0825513,10.1484775 19.7468789,10.4986034 17.5409262,11.1509118 C7.39969078,14.1497125 0,23.5349498 0,34.6484775 C0,48.1794539 10.9690236,59.1484775 24.5,59.1484775 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.5,
    cy: 34.6484775,
    r: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,5.14847751 C27.6666667,5.14847751 30.8333333,6.81514418 34,10.1484775 L15,10.1484775 C18.1666667,6.81514418 21.3333333,5.14847751 24.5,5.14847751 Z",
    id: "Triangle",
    strokeLinejoin: "round",
    transform: "translate(24.500000, 7.648478) scale(1, -1) translate(-24.500000, -7.648478) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    strokeLinejoin: "round",
    points: "22.0444303 1.21333076e-14 27.1661722 1.21333076e-14 34 5.14847751 15 5.14847751"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelry);
export default __webpack_public_path__ + "static/media/jewelry.712ec77cb9ca329e8893bbbeb0f742d3.svg";
export { ForwardRef as ReactComponent };